var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfilterd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_15678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2118 24.9752C12.6563 23.7177 13.8555 22.8168 15.2651 22.8168C16.6747 22.8168 17.874 23.7177 18.3184 24.9752H29.2943V27.1335H18.3184C17.874 28.3909 16.6747 29.2918 15.2651 29.2918C13.8555 29.2918 12.6563 28.3909 12.2118 27.1335H7.71094V24.9752H12.2118ZM18.6868 17.421C19.1312 16.1636 20.3305 15.2627 21.7401 15.2627C23.1497 15.2627 24.349 16.1636 24.7934 17.421H29.2943V19.5793H24.7934C24.349 20.8368 23.1497 21.7377 21.7401 21.7377C20.3305 21.7377 19.1312 20.8368 18.6868 19.5793H7.71094V17.421H18.6868ZM12.2118 9.86683C12.6563 8.6094 13.8555 7.7085 15.2651 7.7085C16.6747 7.7085 17.874 8.6094 18.3184 9.86683H29.2943V12.0252H18.3184C17.874 13.2826 16.6747 14.1835 15.2651 14.1835C13.8555 14.1835 12.6563 13.2826 12.2118 12.0252H7.71094V9.86683H12.2118ZM15.2651 12.0252C15.8611 12.0252 16.3443 11.542 16.3443 10.946C16.3443 10.35 15.8611 9.86683 15.2651 9.86683C14.6691 9.86683 14.1859 10.35 14.1859 10.946C14.1859 11.542 14.6691 12.0252 15.2651 12.0252ZM21.7401 19.5793C22.3361 19.5793 22.8193 19.0962 22.8193 18.5002C22.8193 17.9041 22.3361 17.421 21.7401 17.421C21.1441 17.421 20.6609 17.9041 20.6609 18.5002C20.6609 19.0962 21.1441 19.5793 21.7401 19.5793ZM15.2651 27.1335C15.8611 27.1335 16.3443 26.6504 16.3443 26.0543C16.3443 25.4583 15.8611 24.9752 15.2651 24.9752C14.6691 24.9752 14.1859 25.4583 14.1859 26.0543C14.1859 26.6504 14.6691 27.1335 15.2651 27.1335Z",
    fill: "#5B73E8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 36,
    rx: 3.5,
    stroke: "#5B73E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_15678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilterd);
export default __webpack_public_path__ + "static/media/unfilterd.02b3e60053549ac200336cb904418b4f.svg";
export { ForwardRef as ReactComponent };